import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=3ff097f0&"
import script from "./GlobalDialog.vue?vue&type=script&lang=ts&"
export * from "./GlobalDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports